export const handleDocumentNavigation = ({
  type,
  stats,
  route,
  stateKey,
  navigate,
}) => {
  let dataToPass = [];

  switch (type) {
    case "expired":
      dataToPass = stats.expired;
      break;

    case "1-7":
      dataToPass = stats.oneToSevenDays;
      break;

    case "8-30":
      dataToPass = stats.eightToThirtyDays;
      break;

    case "31-60":
      dataToPass = stats.thirtyOneToSixtyDays;
      break;

    default:
      return;
  }

  navigate(route, {
    state: {
      [stateKey]: dataToPass,
    },
  });
};